<template>
  <div class="personnel-education">
    <personnel_scout
      v-if="String(editpersonnel_temporary.id_card).length > 10"
      :editpersonnel_temporary="{ id_card: editpersonnel_temporary.id_card, }"
      source-type="self"
    />
  </div>
</template>

<script>
import Personnel_scout from '../../components/personnel_scout.vue';
export default {
  components: {
    Personnel_scout
  },
  data() {
    return {
      ApiKey: "HRvec2021",
      editpersonnel_temporary:[],
    };
  },

  mounted() {
    this.loadUserData();
  },

  methods: {
      async loadUserData() {
      try {
        this.loading = true;
        const userSession = JSON.parse(localStorage.getItem("user")) || {};
   
        const result = await this.$http.post("personnel_temporary.php", {
          ApiKey: this.ApiKey,
          id_card: userSession.id_card
        });

        this.editpersonnel_temporary = result.data || {};
      } catch (error) {
        console.error("Error loading user data:", error);
        this.$toast.error("เกิดข้อผิดพลาดในการโหลดข้อมูล");
      } finally {
        this.loading = false;
      }
    },
  },
}
</script>


<style scoped>
.personnel-education {
  padding: 20px;
}
</style>